import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { REPORT_BASE_PATH, REPORT_NEWS_PATH, REPORT_NEWS_AGENTS } from '../../../../constants';
import { ReportType } from '../../../../types/report-types';
import { useIntl } from 'react-intl';
import { createNewAgentsReport } from '../../../../network/reportCrud';
import CreateReport from '../../../../components/CreateReport';

const AgentsReportPage: FC<RouteComponentProps> = ({ history, location }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  
  return (
    <CreateReport
      title={Translation("report.news.agents.title")}
      reportType={ReportType.NEWS_AGENTS}
      onCreate={createNewAgentsReport}
      onBack={() => history.push(`${REPORT_BASE_PATH}${REPORT_NEWS_PATH}${REPORT_NEWS_AGENTS}`)}
      fields={[{
        name: "newsId",
        displayText: Translation("report.news.common.id"),
        type: "text",
        mandatory: true,
      }]}
    />
  )
};

export default AgentsReportPage;
